import * as WEBIFC from "web-ifc";
import * as OBC from "@thatopen/components";
import Experience from '../Experience.js';
import ElementModel from "../../Data/ElementModel.js";
import {convertFragmentMeshToMesh} from "../IFC/IFCMeshHandler.js";




let experience = null;

function showLoadingIndicator() {
    document.getElementById('loading-indicator').classList.remove('hidden-loading');
}

function hideLoadingIndicator() {
    document.getElementById('loading-indicator').classList.add('hidden-loading');
}


//this.experience = new Experience();
let components = null;
let world = null;
let fragmentIfcLoader = null;
let ifcManager = null;
let indexer = null;
let elementModelManager = null;




async function setupIFCLoader() 
{

    components = experience.components;
    world = experience.world;
    fragmentIfcLoader = components.get(OBC.IfcLoader);
    ifcManager = fragmentIfcLoader.ifcManager;
    indexer = components.get(OBC.IfcRelationsIndexer);
    elementModelManager = experience.elementmodelmanager; 

    console.log("setup IFC Loader")
    await fragmentIfcLoader.setup();
    const excludedCats = [
        WEBIFC.IFCTENDONANCHOR,
        WEBIFC.IFCREINFORCINGBAR,
        WEBIFC.IFCREINFORCINGELEMENT,
    ];

    for (const cat of excludedCats) {
        fragmentIfcLoader.settings.excludedCategories.add(cat);
    }

    fragmentIfcLoader.settings.webIfc.COORDINATE_TO_ORIGIN = false;


}

/**
 * Load a File into the viewer
 * called from FileInputChangeListener
 * @param {Object} file 
 * @param {Object} selectedType
 */
export async function loadFile(file, selectedType) 
{

    
    if (!experience) {
        experience = new Experience();
        setupIFCLoader();
    }
    
    try
    {

        showLoadingIndicator(); // Show the loading indicator

        console.log("Load File")
        
        const data = await file.arrayBuffer();
        const buffer = new Uint8Array(data);
        const model = await fragmentIfcLoader.load(buffer); 

        if(experience.worldMatrix === null)
            {
                
                experience.worldMatrix = model.matrixWorld;

            }

        const fileinfo = {name: model.ifcMetadata.name, id: model.ifcMetadata.maxExpressID, filename: file.name, schema: model.ifcMetadata.schema, fileuid: model.uuid, filetype: selectedType};

        await indexer.process(model);  

        await extractElements(model, fileinfo)

        model.name = model.ifcMetadata.maxExpressID;


    }
    catch(error)
    {
        console.error("Error loading file:", error);
    }
    finally{
        hideLoadingIndicator(); // Hide the loading indicator 



    }

    

}


/**
 * Method to extract element information from loaded file
 * @param {FragmentsGroup} model 
 * @param {FileModel} filemodel 
 */
async function extractElements(model, file) 
{
    // Access the ifcManager, assuming it's available through a method or property  
    const types = experience.constants.relevanttypes
    const fragments = model.keyFragments
    const fragmentManager = components.get(OBC.FragmentsManager);


    const elementlist = [];


    for(let type in types)
        {
            
            model.getAllPropertiesOfType(types[type]).then(async (elements) => {
                if (elements) {
                    //console.log(elements);
                    for (const id in elements) 
                        {

                            //console.log(id);


                                const element = elements[id];
                                //console.log(element)

                                let buildingstorey;

                                const buildingStorey = indexer.getEntityRelations(
                                    model,
                                    element.expressID,
                                    "ContainedInStructure",
                                    );
                                    
                                    if (buildingStorey && buildingStorey[0]) {
                                    const storey = await model.getProperties(buildingStorey[0]);

                                    try{buildingstorey = {name: storey.Name.value, elevation: storey.Elevation.value}} catch{}

                                    }


                                let parameters = await extractParameters(model, element);

                                //await iAmAPromise.then(result => result.data);
                                //console.log(parameters)

                                let subtype = await extractSubtype(model, element);

                                let category = experience.constants.ifctypeconverter.Convert(file.filetype, type, subtype);
                                if(category === "undefined")
                                {
                                    continue;
                                }



                                let uuids = []
                                let idInt = parseInt(element.expressID);

                                let mesh;
                                let meshuuid;
                                let imesh


                                let meshes = []
                                let imeshes = []



                                for(const [id, index] of fragments)
                                    {
                                        const fragment = fragmentManager.list.get(index)
                                        //console.log(fragment)
                                        if (fragment.ids.has(idInt)) {
                                            //console.log(model.children.filter(child => child.uuid == index));
                                            
                                            if( model.children.filter(child => child.uuid == index).length > 1)
                                            {
                                                console.log(model.children.filter(child => child.uuid == index));
                                            }

                                            imesh = model.children.filter(child => child.uuid == index)[0]
                                            //imeshuuid = imesh.uuid;
                                            imeshes.push(imesh);
                                            mesh = convertFragmentMeshToMesh(imesh);
                                            mesh.material[0].color.setHex( experience.constants.categorycolorconverter.convert(category))
                                            meshes.push(mesh);
                                            meshuuid = mesh.uuid;
                                            elementlist.push(meshuuid)
                                            uuids.push(index)

                                        }
                                    }

                                let name = "";

                                if(element.Name === undefined | element.Name === null)
                                {
                                    if(element.Description !== undefined | element.Description !== null)
                                    {

                                        name = element.Description.value;

                                    }

                                }
                                else
                                {
                                    name = element.Name.value;
                                }
                                

                                let elementModel = new ElementModel(name, element.expressID, type, subtype, category, parameters, uuids,buildingstorey, mesh, meshuuid, file.name, file.id, file.filename, file.schema, file.fileuid, file.filetype, null, null);
                                //console.log(elementModel)

                                elementModelManager.addModel(elementModel);

                                //experience.elementcount++;

                            }

                            //const treeviewContainer = document.getElementById('treeview-container');
                            //treeviewContainer.innerHTML = '';  // Clear existing tree view                    
                            //const treeview = updateTreeView(this.elementModelManager.getModels());
                            //treeviewContainer.appendChild(treeview);
    
                
                }});

        }

        return elementlist;


}

async function extractParameters(model, element)
{
    const psets = indexer.getEntityRelations(model, element.expressID, "IsDefinedBy");

    let parameters = []

    if(psets)
        {

            //let parameters = []
            for (const expressID of psets) {
                // You can get the pset attributes like this
                const pset = await model.getProperties(expressID);
                // You can get the pset props like this or iterate over pset.HasProperties yourself
                await OBC.IfcPropertiesUtils.getPsetProps(
                    model,
                    expressID,
                    async (propExpressID) => {
                    const prop = await model.getProperties(propExpressID);

                    if(prop.NominalValue)
                        {
                            parameters.push({PropertySet: pset.Name.value, ParameterName: prop.Name.value, Value: prop.NominalValue.value, type: prop.NominalValue.name, id: prop.expressID })

                        }

                    if(prop.EnumerationValues)
                        {
                            parameters.push({PropertySet: pset.Name.value, ParameterName: prop.Name.value, Value: prop.EnumerationValues[0].value, type: prop.EnumerationValues[0].name, id: prop.expressID })
                        }
                    if(prop.ListValues)
                        {
                            parameters.push({PropertySet: pset.Name.value, ParameterName: prop.Name.value, Value: prop.ListValues[0].value, type: prop.ListValues[0].name, id: prop.expressID })
                        }
                    },
                );
                }

                try
                {
                const assignmenttypes = indexer.getEntityRelations(model, element.expressID, "HasAssignments"); //drinkwater/ mechanical --> ifcsystem.ObjectType
                if(assignmenttypes)
                {
                    for (const id of assignmenttypes)
                        {
                            const at = await model.getProperties(id)
                            if(at)
                                {
                                    parameters.push({PropertySet: at.constructor.name, ParameterName: at.Name.value, Value: at.ObjectType.value, id: at.expressID })
                                }
                        }
                }
                }catch{}
        }

        //console.log(parameters)

    return parameters;

}

async function extractSubtype(model, element)
{
    try
    {
        const objectypes = indexer.getEntityRelations(model, element.expressID, "IsTypedBy"); //ifcpipesegmenttype/ ifcdampertype/ ifccablecarriersegmenttype
        if(objectypes)
        {
            for (const id of objectypes)
                {   
                    const ot = await model.getProperties(id)
                    if(ot)
                        {
                            return ot.constructor.name;
                        }    
                }
        }

    }catch
    {
        return "undefined";
    }

}

